import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { Toaster } from 'react-hot-toast';

// Layout Components
import Header from './components/Layout/Header';

// Public Pages
import HomePage from './pages/public/HomePage';
import EvaluationForm from './pages/public/EvaluationForm';

// Admin Pages
import LoginPage from './pages/admin/LoginPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import EventsManagement from './pages/admin/EventsManagement';
import DivisionsManagement from './pages/admin/DivisionsManagement';
import EvaluationManagement from './pages/admin/EvaluationManagement';
import EventResultsDashboard from './pages/admin/EventResultsDashboard';
import CertificateTemplates from './pages/admin/CertificateTemplates';
import ParticipantsManagement from './pages/admin/ParticipantsManagement';

// Components
import ProtectedRoute from './components/Auth/ProtectedRoute';

function App() {
  const { user } = useAuth();

  return (
    <div className="App">
      <Header />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
      
      <main style={{ paddingTop: '24px' }}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/evaluate/:eventId" element={<EvaluationForm />} />
          
          {/* Auth Routes */}
          <Route 
            path="/admin/login" 
            element={user ? <Navigate to="/admin" replace /> : <LoginPage />} 
          />
          
          {/* Protected Admin Routes */}
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/events" element={
            <ProtectedRoute>
              <EventsManagement />
            </ProtectedRoute>
          } />
          <Route path="/admin/divisions" element={
            <ProtectedRoute>
              <DivisionsManagement />
            </ProtectedRoute>
          } />
          <Route path="/admin/evaluations" element={
            <ProtectedRoute>
              <EvaluationManagement />
            </ProtectedRoute>
          } />
          <Route path="/admin/results" element={
            <ProtectedRoute>
              <EventResultsDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/certificate-templates" element={
            <ProtectedRoute>
              <CertificateTemplates />
            </ProtectedRoute>
          } />
          <Route path="/admin/participants" element={
            <ProtectedRoute>
              <ParticipantsManagement />
            </ProtectedRoute>
          } />
          
          {/* 404 Route */}
          <Route path="*" element={
            <div className="container" style={{ padding: '60px 20px', textAlign: 'center' }}>
              <h2>Page Not Found</h2>
              <p>The page you're looking for doesn't exist.</p>
            </div>
          } />
        </Routes>
      </main>
    </div>
  );
}

export default App;